export const DISPATCH_DATE_IN_A_FEW_DAYS = 5 as const;
